import { useTranslation } from 'react-i18next'

import { useCommonQuery } from '~/hooks/useCommonQuery'
import { useIsCoreMember } from '~/hooks/useIsCoreMember'
import { ensureExists } from '~/utils'

export const useCurrentBrandAccountUserRole = (brandAccountId: string) => {
  const { t } = useTranslation()
  const { data } = useCommonQuery()
  const isCoreMember = useIsCoreMember()

  const currentBrandAccountUser = data?.brandAccountRoles?.find(
    (role) => role.brandAccount.id === brandAccountId,
  )

  return isCoreMember
    ? ({
        __typename: 'Role',
        id: 100,
        name: 'CORE_MEMBER',
      } as const)
    : ensureExists(currentBrandAccountUser?.role, t('assertion_failed'))
}
